// @TODO: remove old styles
/**
 * Ryan O'Dowd
 * 2024-12-07
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, isDarkMode, safeAreaInsets}) => {
  return {
    innerContainer: {
      flex: 1,
    },
    scrollView: {
      paddingBottom: safeAreaInsets.bottom + 8,
    },
    filters: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: globalScale * 4,
      padding: globalScale * 8,
    },
    wrinklesWrapper: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      marginTop: 8,
      gap: 4,
      paddingHorizontal: 8,
    },
    translationDivider: {
      width: '100%',
    },
    translationDividerText: {
      marginTop: globalScale * 4,
      marginBottom: globalScale * 0,
      fontSize: globalScale * 14,
      color: isDarkMode ? colors.primaryExtraLight : colors.qqq,
    },

    countsWrapper: {
      marginHorizontal: 8,
      marginBottom: 8,
    },
    totalsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    totalsText: {
      fontSize: globalScale * 15,
      color: colors.white,
      fontFamily: fonts.primaryBold,
    },
    wrinkleCountText: {
      color: colors.accent,
      marginLeft: 8,
    },
  };
};

export default getStyles;
